import type {
  AddToFavoritesPayload,
  FetchCollectionByIdPayload,
  FetchCollectionByIdResponse,
  FetchDocumentPayload,
  FetchDocumentResponse,
  FetchMarketingDataResponse,
  FetchProductsResponse,
  FetchTrainingFilterDataResponse,
  FetchTrainingFilteredResultsPayload,
  FetchTrainingFilteredResultsResponse,
  FetchViewPayload,
  FetchViewResponse,
  GetFavoritesListResponse,
} from "~/repository/common.types";
import type { Banner } from "~/types";

export async function fetchDocument(
  payload: FetchDocumentPayload,
): Promise<FetchDocumentResponse> {
  const { slug } = payload;
  const { $api } = useNuxtApp();
  return await $api("v4")(`documents/${slug}`);
}

export async function fetchMarketingData(): Promise<FetchMarketingDataResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`marketing`);
}

export async function fetchViewData(
  payload: FetchViewPayload,
): Promise<FetchViewResponse> {
  const { $api } = useNuxtApp();
  const { viewName } = payload;
  return await $api("v4")(`views/${viewName}`);
}

export async function fetchCollectionBySlug(
  payload: FetchCollectionByIdPayload,
): Promise<FetchCollectionByIdResponse> {
  const { $api } = useNuxtApp();
  const { slug } = payload;
  return await $api("v4")(`collections/${slug}`);
}

export async function fetchTrainingFilterData(): Promise<FetchTrainingFilterDataResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/training/filters`);
}

export async function fetchTrainingFilteredResults(
  payload: FetchTrainingFilteredResultsPayload,
): Promise<FetchTrainingFilteredResultsResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/videos/trainingfilter`, {
    method: "POST",
    body: payload,
  });
}

export async function fetchProducts(): Promise<FetchProductsResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/products`);
}

export async function getFavoritesList(): Promise<GetFavoritesListResponse> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/subscribers/me/favorites`);
}

export async function addToFavorites(payload: AddToFavoritesPayload) {
  const { $api } = useNuxtApp();
  const { id, type } = payload;
  return await $api("v4")(`/subscribers/me/favorites/${type}/${id}`, {
    method: "POST",
    body: { headers: { "Content-Type": "application/vnd.api+json" } },
  });
}

export async function removeFromFavorites(payload: AddToFavoritesPayload) {
  const { $api } = useNuxtApp();
  const { id, type } = payload;
  return await $api("v4")(`/subscribers/me/favorites/${type}/${id}`, {
    method: "DELETE",
  });
}

export async function getBanners(): Promise<Banner[]> {
  const { $api } = useNuxtApp();
  return await $api("v4")(`/banners/site`);
}
